import styled from "styled-components";
import { accent, black, blackPearl, lightBlue, white } from "../variable";
import transparent from "./../../../assets/icons/transparent_small.png";

export const StyledBasicTextList = styled.div`
  cursor: pointer;
  padding-right: 1rem;
  div {
    margin-bottom: 1.5rem;
  }
`;

export const StyledColorPickerCover = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  pointer-events: none;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const StyledColorPickerPopover = styled.div`
  div[class="saturation-white"],
  div[class="hue-horizontal"] {
    cursor: pointer;
  }

  div[title="TRANSPARENT"] {
    background-image: url(${transparent}) !important;
    background-repeat: no-repeat !important;
    background-size: 16px 16px !important;
  }

  input {
    color: ${black};
    font-family: "Rubik";
  }
`;

export const StyledBrandkitTitle = styled.div`
  font-size: 12px;
  color: ${white};
  text-transform: capitalize;
  text-align: center;
`;

export const StyledEyeDropperIconContainer = styled.span`
  cursor: pointer;
  position: absolute;
  transform: translate(9px, -211px);
  z-index: 1000;
  padding: 4px 8px;
  border-radius: 2px;
  &:hover {
    background-color: rgba(0, 0, 0, 0.16);
  }
`;

export const StyledBorderWhite = styled.div`
  border: 4px solid ${white};
  border-radius: 100%;
  overflow: hidden;
  position: absolute;
  pointer-events: none;
  z-index: 99999;
  will-change: transform;
`;

export const StyledEyeDropperOverlay = styled.div`
  border-radius: 100%;
  border-style: solid;
  border-width: 8px;
  overflow: hidden;
`;

export const StyledEyeDropperOverlayWrapper = styled.div`
  display: flex;
  border-radius: 50%;
`;

export const StyledEyeDropperOverlaySquare = styled.div`
  width: 10px;
  height: 10px;
  box-sizing: border-box;
  border: 1px solid ${lightBlue};
  border-left: none;
  border-bottom: none;
  ${(props) =>
    props.isBorderNeeded &&
    `
     position: relative;
     border: 1px solid ${accent};
     '::after': {
       position: absolute;
       content: "";
       height: 10px;
       width: 10px;
       border: 1px solid ${white};
       top: -2px;
       left: -2px;
   }
 `}
`;

export const StyledHexLabel = styled.div`
  position: absolute;
  width: 64px;
  height: 16px;
  background: ${blackPearl};
  opacity: 0.7;
  left: 60px;
  bottom: 20px;
  display: flex;
  box-sizing: border-box;
  justify-content: center;
  border-radius: 65px;
  zindex: 2;
`;

export const StyledHexValue = styled.span`
  display: flex;
  font-size: 12px;
  line-height: 12px;
  align-items: center;
  text-align: center;
  color: #fff;
`;
